import User from "../../../../src/components/create-token-link";
import * as React from 'react';
export default {
  User,
  React
};